<div class="title-wrapper mb-16">
  <h3 class="title s-16 mb-16">Strategy Rating</h3>
  <p class="text s-16">
    Score: {{ strategyData?.reviewScoreType?.reviewScore }}.
    {{ strategyData?.reviewScoreType?.reviewText }}
  </p>
</div>
<app-correction-needed-form
  [fidelityData]="fidelityData"
  [fidelityFormData]="strategyData"
  (formValueChange)="formValueChange.emit($event)"></app-correction-needed-form>
